export const MuiPopover = {
  defaultProps: {
    sx: {
      zIndex: 13000,
    },
  },
};
